export default function (initialDataInteractor, loginResponseData) {
  initialDataInteractor.user = loginResponseData.person;
}